const preType = 'CONSULTS_';

export const ConsultsActionTypes = {
  GET_DATATABLE_INFO: `${preType}GET_DATATABLE_INFO`,
  SET_CONSULTS_INFO: `${preType}SET_CONSULTS_INFO`,
  SET_CONSULTS_OPEN_DATA: `${preType}SET_CONSULTS_OPEN_DATA`,
  SET_DATATABLE: `${preType}SET_DATATABLE`,
  CHECK_OPEN_DATA: `${preType}CHECK_OPEN_DATA`,
  STORE_DIALOG_BOX: `${preType}STORE_DIALOG_BOX`,
  STORE_DIALOG_BOX_LOADING: `${preType}STORE_DIALOG_BOX_LOADING`,
  STORE_CONSULT: `${preType}STORE_CONSULT`,
  SET_NEW_CHAT_CONTENT: `${preType}SET_NEW_CHAT_CONTENT`,
  SET_START_CHAT: `${preType}SET_START_CHAT`,
  SET_CHAT_CONTENT: `${preType}SET_CHAT_CONTENT`,
  SUBMIT_CONSULT: `${preType}SUBMIT_CONSULT`,
  SUBMIT_CONSULT_WITH_LOGIN: `${preType}SUBMIT_CONSULT_WITH_LOGIN`,
  SUBMIT_CONSULT_WITH_COMPLETE_PROFILE: `${preType}SUBMIT_CONSULT_WITH_COMPLETE_PROFILE`,
  SET_FILE_RESPONSE: `${preType}SET_FILE_RESPONSE`,
  SET_FILE_INITIAL_STATE: `${preType}SET_FILE_INITIAL_STATE`,
  SET_CHAT_FILE: `${preType}SET_CHAT_FILE`,
  GET_EXTENDED_DATATABLE: `${preType}GET_EXTENDED_DATATABLE`,
  SET_INITIAL_STATE: `${preType}SET_INITIAL_STATE`,
  GET_DATATABLE: `${preType}GET_DATATABLE`,
  GET_ELECTRONIC_PRESCRIPTION: `${preType}GET_ELECTRONIC_PRESCRIPTION`,
  SET_ELECTRONIC_PRESCRIPTION: `${preType}SET_ELECTRONIC_PRESCRIPTION`,
  SET_CONSULT_DIALOGUE_ID: `${preType}SET_CONSULT_DIALOGUE_ID`,
};

const getDatatableInfo = (hashUserId: string) => ({ type: ConsultsActionTypes.GET_DATATABLE_INFO, hashUserId: hashUserId });
const setConsultsOpenData = (data: { allowToAnswer: boolean, openData: any }) => ({ type: ConsultsActionTypes.SET_CONSULTS_OPEN_DATA, data: data });
const setDatatable = (data: { data: any }) => ({ type: ConsultsActionTypes.SET_DATATABLE, data: data });
const checkOpenData = (hasAlreadyQuestion: boolean) => ({ type: ConsultsActionTypes.CHECK_OPEN_DATA, hasAlreadyQuestion: hasAlreadyQuestion });
const storeDialogBox = (data: { content: string }) => ({ type: ConsultsActionTypes.STORE_DIALOG_BOX, data: data });
const storeDialogBoxLoading = (loading: boolean) => ({ type: ConsultsActionTypes.STORE_DIALOG_BOX_LOADING, loading: loading });
const storeConsult = (content: string) => ({ type: ConsultsActionTypes.STORE_CONSULT, content: content });
const setNewChatContent = (data: any) => ({ type: ConsultsActionTypes.SET_NEW_CHAT_CONTENT, data: data });
const setChatContent = (data: { content: string }) => ({ type: ConsultsActionTypes.SET_CHAT_CONTENT, data: data });
const submitConsult = () => ({ type: ConsultsActionTypes.SUBMIT_CONSULT });
const submitConsultWithLogin = () => ({ type: ConsultsActionTypes.SUBMIT_CONSULT_WITH_LOGIN });
const submitConsultWithCompleteProfile = () => ({ type: ConsultsActionTypes.SUBMIT_CONSULT_WITH_COMPLETE_PROFILE });
const setStartChat = (startChat: boolean) => ({ type: ConsultsActionTypes.SET_START_CHAT, startChat: startChat });
const setChatFile = (data: { file: object, fileType: string, content: string }) => ({ type: ConsultsActionTypes.SET_CHAT_FILE, data: data });
const getExtendedDatatable = () => ({ type: ConsultsActionTypes.GET_EXTENDED_DATATABLE });
const setInitialState = () => ({ type: ConsultsActionTypes.SET_INITIAL_STATE });
const getDatatable = () => ({ type: ConsultsActionTypes.GET_DATATABLE });
const getElectronicPrescription = () => ({ type: ConsultsActionTypes.GET_ELECTRONIC_PRESCRIPTION });
const setConsultDialogueId = (data: {id: string}) => ({ type: ConsultsActionTypes.SET_CONSULT_DIALOGUE_ID, data: data });

export const ConsultsActions = {
  getDatatableInfo: getDatatableInfo,
  setConsultsOpenData: setConsultsOpenData,
  setDatatable: setDatatable,
  checkOpenData: checkOpenData,
  storeDialogBox: storeDialogBox,
  storeDialogBoxLoading: storeDialogBoxLoading,
  storeConsult: storeConsult,
  setNewChatContent: setNewChatContent,
  setChatContent: setChatContent,
  submitConsult: submitConsult,
  submitConsultWithLogin: submitConsultWithLogin,
  submitConsultWithCompleteProfile: submitConsultWithCompleteProfile,
  setStartChat: setStartChat,
  setChatFile: setChatFile,
  getExtendedDatatable: getExtendedDatatable,
  setInitialState: setInitialState,
  getDatatable: getDatatable,
  getElectronicPrescription: getElectronicPrescription,
  setConsultDialogueId: setConsultDialogueId,
};
